/* src/app/core/modules/shared/components/detail-row/detail-row.component.scss */
/*# sourceMappingURL=/avvera/dev/detail-row.component.css.map */
